import { bindPmElTableDocPinnedOverflowClass } from '../utils/pmElTableScrollEdge.js';

function resolveTableRoot(el) {
  if (el?.classList?.contains('el-table') && el.classList.contains('pm-el-table--doc-pinned')) {
    return el;
  }
  return el?.querySelector?.('.el-table.pm-el-table--doc-pinned') ?? null;
}

/** 实测横向溢出：pm-table-doc-pinned--x-overflow（投影）/ 无此类（短线） */
export const vPmDocPinnedScrollEdge = {
  mounted(el) {
    const table = resolveTableRoot(el);
    if (!table) return;
    el.__pmDocPinnedScrollUnbind = bindPmElTableDocPinnedOverflowClass(table);
  },
  updated(el) {
    const table = resolveTableRoot(el);
    if (!table) return;
    el.__pmDocPinnedScrollUnbind?.();
    el.__pmDocPinnedScrollUnbind = bindPmElTableDocPinnedOverflowClass(table);
  },
  unmounted(el) {
    el.__pmDocPinnedScrollUnbind?.();
    el.__pmDocPinnedScrollUnbind = null;
  },
};
